import BaseModel from './BaseModel';
import { asyncFn } from './utils';

class LogModel extends BaseModel {
  constructor(data = {}) {
    super(data);
    this.orderLogModel = {
      request: this.buildActionName('request', 'order', 'log'),
      response: this.buildActionName('response', 'order', 'log'),
      error: this.buildActionName('error', 'order', 'log'),
    };

    this.orderLogAllModel = {
      request: this.buildActionName('request', 'order', 'log', 'all'),
      response: this.buildActionName('response', 'order', 'log', 'all'),
      error: this.buildActionName('error', 'order', 'log', 'all'),
    };

    this.initialState = {
      current: {
        isLoading: false,
        error: false,
        errorMessage: '',
        data: [],
        total: null,
      },
      all: {
        isLoading: false,
        error: false,
        errorMessage: '',
        data: [],
        total: null,
      },
    };
  }

  getLogs = (orderId, body) => asyncFn({
    body, url: `${this.url}/${orderId}`, method: 'POST', model: this.orderLogModel,
  })

  getAllLogs = body => asyncFn({
    body, url: this.url, method: 'POST', model: this.orderLogAllModel,
  })

  reducer = (state = this.initialState, action) => {
    switch (action.type) {
      case this.orderLogModel.request: {
        return {
          ...state,
          current: {
            ...state.current,
            isLoading: true,
            error: false,
            errorMessage: '',
          },
        };
      }
      case this.orderLogModel.error: {
        return {
          ...state,
          current: {
            ...state.current,
            isLoading: false,
            error: true,
            errorMessage: action.message,
          },
        };
      }
      case this.orderLogModel.response: {
        return {
          ...state,
          current: {
            ...state.current,
            isLoading: false,
            data: action.payload.list,
            total: action.payload.total,
          },
        };
      }
      case this.orderLogAllModel.request: {
        return {
          ...state,
          all: {
            ...state.all,
            isLoading: true,
            error: false,
            errorMessage: '',
          },
        };
      }
      case this.orderLogAllModel.error: {
        return {
          ...state,
          all: {
            ...state.all,
            isLoading: false,
            error: true,
            errorMessage: action.message,
          },
        };
      }
      case this.orderLogAllModel.response: {
        return {
          ...state,
          all: {
            ...state.all,
            isLoading: false,
            data: action.payload.list,
            total: action.payload.total,
          },
        };
      }
      default:
        return state;
    }
  }
}

export default LogModel;



// WEBPACK FOOTER //
// ./src/models/LogModel.js